import { render } from "./ForgotPasscode.vue?vue&type=template&id=a84a8cfe"
import script from "./ForgotPasscode.vue?vue&type=script&lang=js"
export * from "./ForgotPasscode.vue?vue&type=script&lang=js"

import "./ForgotPasscode.vue?vue&type=style&index=0&id=a84a8cfe&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__